import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withProps, withState, withHandlers, compose, branch, lifecycle, renderNothing } from 'recompose'

import * as PlaybookSelectors from 'app/modules/playbook/selectors'
import * as SegmentSelectors from 'app/modules/segment/selectors'
import * as SegmentActions from 'app/modules/segment/actions'
import * as PlaybookActions from 'app/modules/playbook/actions'
import { EmailThemeType, EmailPreviewView } from 'app/modules/playbook/constants'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import * as UserSelectors from 'app/modules/user/selectors'

import EmailMessagePreview from './component'

const mapStateToProps = (state, { params: { playbookId }}) => ({
  playbookId: playbookId,
  orgUsers: UserSelectors.currentOrgUsersAlphabetical(state),
  userListIds: SegmentSelectors.segments(state),
  emailMessage: PlaybookSelectors.emailMessage(state),
  emailRenderedPreview: PlaybookSelectors.getRenderedEmailPreview(state, playbookId),
  defaultEmbed: EmbedSelectors.getEmbedConfig(state),
  sendTestEmailLoading: PlaybookSelectors.getSendTestEmailLoading(state),
  isTemplateContactPreviewLoading: PlaybookSelectors.isTemplateContactPreviewLoading(state),
  firstAction: PlaybookSelectors.firstAction(state),
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      setEmailTheme: PlaybookActions.setEmailTheme,
      sendTestEmail: PlaybookActions.sendTestEmail,
      fetchRenderedEmailPreview: PlaybookActions.fetchDataPreviewEmail,
      fetchSegmentList: SegmentActions.fetchSegmentList,
    },
    dispatch
  ),
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  branch(({ defaultEmbed, orgUsers }) => !defaultEmbed || !orgUsers.size, renderNothing),
  lifecycle({
    componentDidMount() {
      const { actions } = this.props
      actions.fetchSegmentList()
    },
  }),
  withProps(props => ({
    message: props.emailMessage.message,
    headline: props.emailMessage.title,
    fromNameOverride: props.emailMessage.sendFromOverride,
    fromEmailOverride: props.emailMessage.senderEmailOverride,
    simpleSelected: props.emailMessage.emailTheme === EmailThemeType.SIMPLE,
    styledSelected: props.emailMessage.emailTheme === EmailThemeType.STYLED,
    backgroundColor: props.defaultEmbed.theme.backgroundColor,
    organizationName: props.defaultEmbed.organizationName,
    selectedUser: props.orgUsers.toJS().find(user => user.id === props.emailMessage.authorId),
    userListIdOptions: props.userListIds
      .map(segment => Object.assign(segment.toJS(), { label: segment.name, value: segment.id }))
      .toJS(),
    EmailPreviewView,
  })),
  withState('selectedPreview', 'changeSelectedPreview', EmailPreviewView.TEMPLATE),
  withState('selectedUserListOption', 'changeUserListOption', undefined),
  withProps(props => ({
    showRenderedPreview: props.selectedPreview === EmailPreviewView.RENDERED_DATA,
  })),
  withHandlers({
    onStyledClick: props => () => {
      const { actions: { setEmailTheme }} = props
      setEmailTheme(EmailThemeType.STYLED)
    },
    onSimpleClick: props => () => {
      const { actions: { setEmailTheme }} = props
      setEmailTheme(EmailThemeType.SIMPLE)
    },
    onSendTestEmailClick: props => () => {
      const { actions: { sendTestEmail }} = props
      sendTestEmail({})
    },
    onDefaultPreviewClick: props => () => {
      const { changeSelectedPreview, playbookId, actions: { fetchRenderedEmailPreview }} = props
      fetchRenderedEmailPreview({ playbookId, userListIds: []})
      changeSelectedPreview(EmailPreviewView.DEFAULTS)
    },
    onTemplatePreviewClick: props => () => {
      const { changeSelectedPreview } = props
      changeSelectedPreview(EmailPreviewView.TEMPLATE)
    },
    onRenderedPreviewClick: props => () => {
      const { changeSelectedPreview } = props
      changeSelectedPreview(EmailPreviewView.RENDERED_DATA)
    },
    onRefreshPreviewClick: props => () => {
      const { selectedUserListOption, firstAction, playbookId, actions: { fetchRenderedEmailPreview }} = props
      if (!!selectedUserListOption)
        // make sure the option from the select box was not the "null" option
        fetchRenderedEmailPreview({ playbookId, userListIds: [selectedUserListOption.id], campaignId: firstAction.get('campaignId') })
    },
    handleChangeUserListOption: props => option => {
      const { changeUserListOption, changeSelectedPreview, firstAction, playbookId, actions: { fetchRenderedEmailPreview }} = props
      changeUserListOption(option)
      fetchRenderedEmailPreview({ playbookId, userListIds: [option.id], campaignId: firstAction.get('campaignId') })
      changeSelectedPreview(EmailPreviewView.RENDERED_DATA)
    },
  })
)(EmailMessagePreview)



// WEBPACK FOOTER //
// ./src/scripts/components/playbook/components/EmailMessagePreview/index.js